import { useEffect, useState } from 'react';
import httpService from './http.service';
import axios from 'axios';

function useHttpApiCall(payload) {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);

  useEffect(() => {
    const callApi = async (cancelToken) => {
      try {
        setLoading(true);
        setError(undefined);
        const response = await httpService.fetch(payload, cancelToken);
        setData(response);
      } catch (error) {
        console.log('API error:', error);
        
        // Only handle non-417 errors here
        // 417 errors are handled by the interceptor automatically
        if (error.response?.status !== 417) {
          setError(error);
          setData(undefined);
        }
        // For 417 errors, the interceptor will handle refresh/logout
        // so we don't need to do anything here
      } finally {
        setLoading(false);
      }
    };

    let isComponentMounted = true;
    const source = axios.CancelToken.source();
    
    if (isComponentMounted && payload) {
      callApi(source.token);
    }
    
    return () => {
      isComponentMounted = false;
      source.cancel('Cancelling Request');
    };
  }, [payload]);

  return [data, loading, error];
}

export default useHttpApiCall;